<template lang="slm">
.Column-box
	a.Column-box-content :href="link.url"
		h2.title.Title-only {{link.title}}
		p {{link.description}}
</template>

<script>
export default {
  data () {
    return {
    }
  },
  components: {
  },
  props: ['link']
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/LinkCard.vue